export default {"src":"/_next/static/media/question-icon.15a0f066.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};